import { render } from "./index.vue?vue&type=template&id=13877386"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layout/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13877386"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13877386', __exports__)) {
    api.reload('13877386', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=13877386", () => {
    api.rerender('13877386', render)
  })

}


export default __exports__